export const LOOP_TIMES_VALUE = 5;
export const START_DATE_VALUE = 130;
export const END_DATE_VALUE = 131;
export const PING_FOR_ATTRIBUTION_VALUE = 132;
export const START_DATE_NAME = 'StartDateTime';
export const END_DATE_NAME = 'EndDateTime';
export const PING_FOR_ATTRIBUTION_NAME = 'RequirePingForAttribution';
